import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { getDefaultPathForUser } from '../config/panelRoutes';
import toast from 'react-hot-toast';
import './Login.css';
import { getSupabaseInitError } from '../config/supabase';
import { storagePublicBaseUrl } from '../config/env';
const heroBackgroundUrl = storagePublicBaseUrl
  ? `${storagePublicBaseUrl}/storage/v1/object/public/app-assets/startscreen-background/hero-background1.png`
  : null;
const pinsImageUrl = storagePublicBaseUrl
  ? `${storagePublicBaseUrl}/storage/v1/object/public/app-assets/splash%20screen/pins1.png`
  : null;

const PARTICLES_CONFIG = {
  particles: {
    number: { value: 80, density: { enable: true, value_area: 800 } },
    color: { value: '#ffffff' },
    shape: { type: 'circle', stroke: { width: 0, color: '#000000' }, polygon: { nb_sides: 5 }, image: { src: '', width: 100, height: 100 } },
    opacity: { value: 0.5, random: false, anim: { enable: false, speed: 1, opacity_min: 0.1, sync: false } },
    size: { value: 3, random: true, anim: { enable: false, speed: 40, size_min: 0.1, sync: false } },
    line_linked: { enable: true, distance: 150, color: '#ffffff', opacity: 0.4, width: 1 },
    move: { enable: true, speed: 6, direction: 'none', random: false, straight: false, out_mode: 'out', bounce: false, attract: { enable: false, rotateX: 600, rotateY: 1200 } },
  },
  interactivity: {
    detect_on: 'canvas',
    events: { onhover: { enable: true, mode: 'grab' }, onclick: { enable: true, mode: 'push' }, resize: true },
    modes: {
      grab: { distance: 100, line_linked: { opacity: 1 } },
      bubble: { distance: 400, size: 40, duration: 2, opacity: 8, speed: 3 },
      repulse: { distance: 200, duration: 0.4 },
      push: { particles_nb: 4 },
      remove: { particles_nb: 2 },
    },
  },
  retina_detect: true,
};

const PARTICLES_ID = 'login-particles-js';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const configError = getSupabaseInitError();
  const { login } = useAuth();
  const navigate = useNavigate();
  const particlesInstanceRef = useRef(null);

  useEffect(() => {
    let intervalId = null;
    const initParticles = () => {
      if (typeof window.particlesJS !== 'function') return;
      const el = document.getElementById(PARTICLES_ID);
      if (!el) return;
      window.particlesJS(PARTICLES_ID, PARTICLES_CONFIG);
      if (window.pJSDom && window.pJSDom.length > 0) {
        particlesInstanceRef.current = window.pJSDom[window.pJSDom.length - 1];
      }
    };
    if (typeof window.particlesJS === 'function') {
      initParticles();
    } else {
      intervalId = setInterval(() => {
        if (typeof window.particlesJS === 'function') {
          clearInterval(intervalId);
          intervalId = null;
          initParticles();
        }
      }, 50);
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
      if (particlesInstanceRef.current && particlesInstanceRef.current.fn?.vendors?.destroypJS) {
        particlesInstanceRef.current.fn.vendors.destroypJS();
      }
      particlesInstanceRef.current = null;
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedEmail = email?.trim();
    const trimmedPassword = password?.trim();
    if (!trimmedEmail || !trimmedPassword) {
      toast.error('Proszę wypełnić wszystkie pola');
      return;
    }
    setIsLoading(true);
    try {
      const result = await login(trimmedEmail, trimmedPassword);
      if (result.success) {
        const path = result.user ? getDefaultPathForUser(result.user) : '/';
        navigate(path);
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error(error.message || 'Błąd logowania');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      {heroBackgroundUrl && (
        <div
          className="login-hero-background"
          style={{ backgroundImage: `url(${heroBackgroundUrl})` }}
          aria-hidden="true"
        />
      )}
      <div id={PARTICLES_ID} className="login-particles-js" aria-hidden="true" />
      <div className="login-ring-container">
        <span className="ring-shape" aria-hidden="true" />
        <span className="ring-shape" aria-hidden="true" />
        <span className="ring-shape" aria-hidden="true" />
        <div className="login-box">
          {pinsImageUrl && (
            <img src={pinsImageUrl} alt="" className="login-header-image" />
          )}
          <h2>
            <span className="login-title-biel">Biel</span>
            <span className="login-title-appka">appka</span>
          </h2>
          <p className="login-subtitle">Panel administracyjny</p>
          {configError && (
            <p
              className="login-config-error"
              style={{
                color: '#b91c1c',
                fontSize: '14px',
                marginBottom: '12px',
                lineHeight: 1.4,
              }}
            >
              Błąd konfiguracji panelu: {configError}
            </p>
          )}
          <form onSubmit={handleSubmit}>
            <div className="input-box">
              <input
                id="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isLoading}
                autoComplete="off"
              />
              <label htmlFor="login-email">Email</label>
            </div>
            <div className="input-box">
              <input
                id="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isLoading}
                autoComplete="current-password"
              />
              <label htmlFor="login-password">Hasło</label>
            </div>
            <button type="submit" className="login-btn" disabled={isLoading}>
              {isLoading ? 'Logowanie...' : 'Zaloguj się'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
